import { InputField } from "../Common/inputField";
import TrashIcon from "../../assets/trash-outline.svg";
import { DatePickerInput } from "../Common/datePicker";
import { CurrencyInputField } from "../Common/currencyInput";

interface EmploymentBoxProps {
  onRemove: () => void;
  employerName: string;
  jobTitle: string;
  annualBasePay: string;
  annualBonuses: string;
  annualOvertime: string;
  annualCommission: string;
  startDate: Date | null;

  employerNameError?: string;
  jobTitleError?: string;
  apperoximateStartDateError?: string;
  annualBasePayError?: string;
  annualBonusesError?: string;
  annualOvertimeError?: string;
  annualCommissionError?: string;
  startDateError?: string;
  label: string;
  setEmployerName: (value: string) => void;
  setJobTitle: (value: string) => void;
  setAnnualBasePay: (value: string) => void;
  setAnnualBonuses: (value: string) => void;
  setAnnualOvertime: (value: string) => void;
  setAnnualCommission: (value: string) => void;
  setStartDate: (date: Date | null) => void;
}

const EmploymentBox = ({
  onRemove,
  employerName,
  employerNameError,
  jobTitle,
  jobTitleError,
  annualBasePay,
  annualBasePayError,
  annualBonuses,
  annualBonusesError,
  annualOvertime,
  annualOvertimeError,
  annualCommission,
  annualCommissionError,
  startDate,
  startDateError,
  label,
  setEmployerName,
  setJobTitle,
  setAnnualBasePay,
  setAnnualBonuses,
  setAnnualOvertime,
  setAnnualCommission,
  setStartDate,
}: EmploymentBoxProps) => {
  return (
    <div className="rounded-[8px] border-[#E5E7EB] border-2">
      <div className="font-medium flex items-center justify-between w-full bg-[#E5E7EB]/50 rounded-t-[8px] border-b-[#E5E7EB] border-b-2 px-3 py-4">
        <div>{label} Employment</div>
        <button
          type="button"
          className="flex items-center gap-1 text-[#EF4444] text-xs font-medium"
          onClick={onRemove}
        >
          Delete <img src={TrashIcon} alt="" />
        </button>
      </div>
      <div className="p-4 space-y-6">
        <div className="space-y-2">
          <div className="text-z-dark-moss-green font-medium">
            Employment Details
          </div>
          <div className="grid lg:grid-cols-2 gap-4">
            <div className="w-full space-y-1">
              <InputField
                id="employerName"
                label="Employer Name*"
                placeholder="Enter employer name"
                value={employerName}
                onChange={(e) => setEmployerName(e.target.value)}
              />
              {employerNameError && (
                <p className="text-red-600 text-sm">{employerNameError}</p>
              )}
            </div>
            <div className="w-full space-y-1">
              <InputField
                id="jobTitle"
                label="Job Title*"
                placeholder="Enter job title"
                value={jobTitle}
                onChange={(e) => setJobTitle(e.target.value)}
              />
              {jobTitleError && (
                <p className="text-red-600 text-sm">{jobTitleError}</p>
              )}
            </div>
            <div className="w-full space-y-1">
              <DatePickerInput
                label="Approximate Start Date*"
                selectedDate={startDate}
                onDateChange={setStartDate}
              />
              {startDateError && (
                <p className="text-red-600 text-sm">{startDateError}</p>
              )}
            </div>
          </div>
        </div>
        <div className="space-y-2">
          <div className="text-z-prussian-blue font-medium">Income Details</div>
          <div className="grid lg:grid-cols-2 gap-4">
            <div className="w-full space-y-1">
              <CurrencyInputField
                id="annualBasePay"
                label="Annual Base Pay ($)*"
                placeholder="Enter base pay"
                value={annualBasePay}
                onChange={setAnnualBasePay}
              />
              {annualBasePayError && (
                <p className="text-red-600 text-sm">{annualBasePayError}</p>
              )}
            </div>
            <div className="w-full space-y-1">
              <CurrencyInputField
                id="annualBonuses"
                label="Annual Bonuses ($)*  (Two-year average)"
                placeholder="Enter annual bonuses"
                value={annualBonuses}
                onChange={setAnnualBonuses}
              />
              {annualBonusesError && (
                <p className="text-red-600 text-sm">{annualBonusesError}</p>
              )}
            </div>
            <div className="w-full space-y-1">
              <CurrencyInputField
                id="annualOvertime"
                label="Annual Overtime ($)* (Two-year average)"
                placeholder="Enter annual overtime"
                value={annualOvertime}
                onChange={setAnnualOvertime}
              />
              {annualOvertimeError && (
                <p className="text-red-600 text-sm">{annualOvertimeError}</p>
              )}
            </div>
            <div className="w-full space-y-1">
              <CurrencyInputField
                id="annualCommission"
                label="Annual Commission ($)* (Two-year average)"
                placeholder="Enter annual commission"
                value={annualCommission}
                onChange={setAnnualCommission}
              />
              {annualCommissionError && (
                <p className="text-red-600 text-sm">{annualCommissionError}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { EmploymentBox };
